import {
    IAgendaTecnicoBody,
    IAgendaTecnicoRequest,
    IAgendamento,
    IAtendimentoVinculadoAAtendimento,
    IEditAgendaCompromisso,
    IFiltroListarAgendamento,
    IListaAgendamento,
    IListaCompromissoDisponivel,
} from "../../../Interfaces/AssistenciaTecnica/Agendamento/AgendamentoInterfaces";
import Axios from "../../Config/API";
import Service from "../../Service";

export function ListarAgendamentosDeAtendimentoService(idCaso: number) {
    return Service(
        Axios.get<Array<IAgendamento>>(
            `/home/agendamento/listaragendamentosdeatendimento?idCaso=${idCaso}`
        )
    );
}

export function ListarCompromissoDisponiveisVistoriaAgendaService(
    DT_INICIO: string | Date,
    DT_FIM: string | Date,
    ID_TIPO_COMPROMISSO?: number,
    ID_PRODUTO?: number,
    ID_USUARIO?: number,
    NR_QUANTIDADE_DIA?: number
) {
    return Service(
        Axios.get<Array<IListaCompromissoDisponivel>>(
            `/home/agendamento/listarcompromissodisponiveisvistoriaagenda?DT_INICIO=${DT_INICIO}&DT_FIM=${DT_FIM}&ID_PRODUTO=${ID_PRODUTO}&ID_USUARIO=${ID_USUARIO}&ID_TIPO_COMPROMISSO=${ID_TIPO_COMPROMISSO}${
                NR_QUANTIDADE_DIA
                    ? `&NR_QUANTIDADE_DIA=${NR_QUANTIDADE_DIA}`
                    : ""
            }`
        )
    );
}

export function ListarAgendaTecnicoService(requestBody: IAgendaTecnicoRequest) {
    return Service(
        Axios.post<IAgendaTecnicoBody>(
            `/home/compromissodisponivelvistoriahorarios/listaagendatecnico`,
            requestBody
        )
    );
}

export function CriarAgendamentoDeAtendimentoService(
    requestBody: IAgendamento,
    idCompromissoDisponivelVistoria?: number
) {
    return Service(
        Axios.post<Array<IAgendamento>>(
            `/home/agendamento/criaragendamentodeatendimento?idCompromissoDisponivelVistoria=${
                idCompromissoDisponivelVistoria ?? 0
            }`,
            requestBody
        )
    );
}

export function ListarAgendamentosService(
    filtro: Partial<IFiltroListarAgendamento>
) {
    return Service(
        Axios.get<Array<IListaAgendamento>>(
            `/home/agendamento/listaragendamentos?DT_FIM=${
                filtro.DT_FIM?.toISOString() ?? ""
            }&DT_INICIO=${
                filtro.DT_INICIO?.toISOString() ?? ""
            }&FL_FILTRAR_VENCIDAS=${
                filtro.FL_FILTRAR_VENCIDAS ?? ""
            }&ID_COMPROMISSO=${filtro.ID_COMPROMISSO ?? ""}
            &ID_PRODUTO=${filtro.ID_PRODUTO ?? ""}&ID_USUARIO=${
                filtro.ID_USUARIO ?? ""
            }&FL_APENAS_MEUS_AGENDAMENTOS=${
                filtro.FL_APENAS_MEUS_AGENDAMENTOS ?? false
            }&ID_TIPO_CASO=${filtro.ID_TIPO_CASO ?? ""}
            &ID_TIPO_COMPROMISSO=${filtro.ID_TIPO_COMPROMISSO}
            &ID_GRUPO=${filtro.ID_GRUPO ?? ""}`
        )
    );
}

export function ListarCasoVinculadosAgendamentoService(idCompromisso: number) {
    return Service(
        Axios.get<Array<IAtendimentoVinculadoAAtendimento>>(
            `/home/agendamento/listarcasosvinculados?idCompromisso=${idCompromisso}`
        )
    );
}

export function DeletarAgendamentoDeAtendimentoService(ID_COMPROMISSO: number) {
    return Service(
        Axios.delete<IAgendamento>(
            `/home/agendamento/deletaragendamentodeatendimento?idCompromisso=${ID_COMPROMISSO}`
        )
    );
}

export function AlterarAgendamentoService(requestBody: IEditAgendaCompromisso) {
    return Service(
        Axios.put(`/home/agendamento/AlterarAgendamento?`, requestBody)
    );
}

export function MarcarAgendamentoConcluidoService(
    ID_COMPROMISSO: number,
    DT_FIM: string
) {
    return Service(
        Axios.put(
            `/home/agendamento/concluiragendamento?ID_COMPROMISSO=${ID_COMPROMISSO}&DT_FIM=${DT_FIM}`
        )
    );
}
